import {
  Box,
  Grid,
  Card,
  Image,
  Heading,
  Text,
  Stack,
  Flex,
  Link,
  Icon,
} from "@chakra-ui/react";
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from "../components/ui/accordion";
import React, { useEffect } from "react";
import CustomCard from "../components/custom/CustomCard";
import { LuMail } from "react-icons/lu";
import { BiPhone } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import ContactForm from "../components/custom/ContactForm";
import {
  FaXTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa6";
import { useColorModeValue } from "../components/ui/color-mode";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ContactScreen = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");

  const faqs = [
    {
      que: "Are your services truly spam-free?",
      ans: "Yes, we guarantee no spam or unnecessary communication. You’ll only receive updates and advice directly related to your tax filings.",
    },
    {
      que: "What happens if I miss the tax filing deadline?",
      ans: "Missing deadlines may result in penalties or interest. We assist with belated filings to minimize these issues.",
    },
    {
      que: "Is my data secure with you?",
      ans: "Absolutely. Your privacy is our top priority, and we use secure systems to ensure your data is fully protected.",
    },
    {
      que: "Do you help with tax notices or penalties?",
      ans: "Yes, our experts can guide you in addressing tax notices and reducing penalties effectively.",
    },
    {
      que: "How do you ensure the accuracy of my filings?",
      ans: "Our tax professionals thoroughly review all details to maximize benefits and eliminate errors.",
    },
    {
      que: "Can I get ongoing tax advice and support?",
      ans: "Yes, we offer year-round support for tax planning, compliance, and filing assistance.",
    },
    {
      que: "Why should I choose your services?",
      ans: "We provide expert guidance, affordable pricing, a hassle-free process, and trusted, certified assistance—all while respecting your time and privacy.",
    },
  ];

  const socialmedias = [
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/360fintax/",
    },
    {
      icon: FaFacebookF,
      url: "#",
    },
    {
      icon: FaXTwitter,
      url: "#",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/company/360fintax/",
    },
  ];
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>Contact Us - 360fintax</title>
        <meta
          name="description"
          content="Get in touch with 360fintax for expert tax and financial services. We're here to assist you with your tax-related queries and provide tailored solutions."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/contact"
        />
      </Helmet>
      {/* Banner */}
      <Stack
        bgColor={secondBg}
        justifyContent="center"
        alignItems="center"
        py="20"
        px="10"
        gap="20"
      >
        <Stack textAlign="center" pt={20}>
          <Text
            fontSize="md"
            color="#008080"
            fontWeight="bold"
            letterSpacing="widest"
          >
            CONTACT US
          </Text>
          <Text
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            lineHeight="2.5rem"
          >
            Need additional support?
            <br /> We’re here to help!
          </Text>
        </Stack>
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
          px={{ base: "0", md: "0", lg: "20" }}
          gap={{ base: "10", md: "10", lg: "10" }}
          mb={10}
          justifyItems="center"
        >
          <CustomCard
            src="../assets/tax3d.png"
            boxSize={100}
            title="Find The Right Policy For You"
            description="360fintax advisors aren’t regular insurance agents. We are the support system in your corner. Speak to us to get any insurance or policy-related query resolved!"
            button1="Talk to an Advisor"
          />
          <CustomCard
            title="For General Queries"
            description="If you have a query regarding services purchased through 360fintax, connect with our team at"
            children={
              <Stack gap="5" pt="5">
                <Link
                  href="mailto:connect.360fintax@gmail.com"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex alignItems="center" gap="3" color="#008080">
                    <LuMail size="28" />
                    <Text fontWeight="bold">connect.360fintax@gmail.com</Text>
                  </Flex>
                </Link>
                <Link
                  href="tel:+919757476672"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex alignItems="center" gap="3" color="#008080">
                    <BiPhone size="28" />
                    <Text fontWeight="bold">+919757476672</Text>
                  </Flex>
                </Link>
                <Link
                  href="https://wa.me/+919757476672"
                  _hover={{ textDecoration: "none" }}
                  _focus={{ outline: "none" }}
                >
                  <Flex alignItems="center" gap="3" color="#008080">
                    <FaWhatsapp size="28" />
                    <Text fontWeight="bold">Chat on WhatsApp</Text>
                  </Flex>
                </Link>
                <Image
                  position="absolute"
                  bottom="1"
                  right="0"
                  src="../assets/girl.png"
                  boxSize={{ base: "24", md: "32", lg: "40" }}
                  loading="eager"
                />
              </Stack>
            }
          />
        </Grid>
      </Stack>

      {/* Form */}
      <Grid
        templateColumns={{ base: "1fr", md: "1.5fr 2fr" }}
        px={{ base: "5", md: "10", lg: "40" }}
        py={20}
        gap={{ base: "10", md: "10", lg: "10" }}
        mb={10}
        justifyItems="center"
        className="fade-section"
        data-scroll
        data-scroll-class="fade-in"
        data-aos="zoom-in"
      >
        {/* Image */}
        <Stack
          bgColor={{ base: "#f6f6ff", _dark: "#0f031b" }}
          boxShadow={{
            base: "rgba(0, 0, 0, 0.24) 0px 3px 5px;",
            _dark: "rgba(255, 255, 255, 0.24) 0px 3px 5px",
          }}
          borderRadius="2xl"
          alignItems="center"
          p="10"
        >
          <Image src="../assets/contact.png" boxSize="80%" loading="eager" />
          <Stack alignItems="center">
            <Heading
              as="h6"
              size={{ base: "xs", md: "xs", lg: "lg" }}
              pb={{ base: "0", md: "4" }}
              fontWeight="bold"
              color="#008080"
            >
              CONNECT WITH US
            </Heading>

            {/* Social Icons */}
            <Flex gap={5}>
              {socialmedias.map((social) => (
                <Link href={social.url}>
                  <Icon
                    color="#008080"
                    _hover={{ color: "#66b2b2", transform: "scale(1.3)" }}
                    transition="transform 0.2s ease-in-out"
                    boxSize={6}
                  >
                    <social.icon />
                  </Icon>
                </Link>
              ))}
            </Flex>
          </Stack>
        </Stack>

        {/* Form */}
        <ContactForm />
      </Grid>
      {/* FAQS */}
      <Stack pb={20} gap={10} alignItems="center" id="faq" data-aos="fade-up">
        <Text
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          lineHeight="2.5rem"
        >
          Frequently asked questions
        </Text>
        <AccordionRoot collapsible w={{ base: "xs", md: "2xl" }}>
          {faqs.map((faq, index) => (
            <AccordionItem
              borderColor="#66b2b2"
              value={`faq${index}`}
              key={index}
              py={3}
            >
              <AccordionItemTrigger>{faq.que}</AccordionItemTrigger>
              <AccordionItemContent>{faq.ans}</AccordionItemContent>
            </AccordionItem>
          ))}
        </AccordionRoot>
      </Stack>
    </>
  );
};

export default ContactScreen;
